import {
	DeviationModel,
} from 'models/deviation.model';
import {
	EntryListItem, EntryListModal,
} from '../ entryListModal/EntryListModal';
import {
	getDeviationHeader,
} from '../deviation/Deviation';


interface DeviationListProps {
  /**
   * The name of the current lot, if any
   */
  deviations: DeviationModel[],

	/*
	 * Function to be called when modal is closed without a selection being made
	 */
	onClose: () => void,

	/*
	 * Function to be called when a deviation is selected
	 */
	onChange: (deviation: DeviationModel) => void,
}

const DeviationList = ({
	deviations,
	onClose,
	onChange,
}: DeviationListProps) => (
	<EntryListModal
		onClose={onClose}
		title="Velg avvik"
	>
		{deviations.map(deviation => (
			<EntryListItem<DeviationModel>
				key={`deviation-list-${deviation.id}`}
				title={getDeviationHeader(deviation.code)}
				description={deviation.comment}
				data={deviation}
				onClick={onChange}
			/>
		))}
	</EntryListModal>
);

export default DeviationList;